import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f4da391"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BillingModal__selects" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Выберите бухгалтера", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Этап выставления", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Период выставления", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Тип выставления", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Тариф", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Включить биллинг для", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Формировать транскрипт", -1))
const _hoisted_9 = { class: "flex mt-3" }
const _hoisted_10 = { class: "flex items-center justify-end" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Минимальный вес", -1))
const _hoisted_12 = { class: "flex items-start justify-between gap-6" }
const _hoisted_13 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "extra-large BillingModal",
    title: "Свойства Биллинга",
    "without-footer": "",
    loading: _ctx.isLoading,
    onCancel: _ctx.emitCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createVNode(_component_the_select, {
            placeholder: "Выберите бухгалтера",
            value: _ctx.payload_state.accountantId,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload_state.accountantId) = $event)),
            loading: _ctx.data_state.accountants.is_loading,
            options: _ctx.data_state.accountants.list,
            failed: _ctx.data_state.accountants.is_failed,
            "error-text": "При получении списка бухгалтеров произошла ошибка",
            "search-by": "name",
            "select-by": "id",
            label: "name",
            "infinite-scroll": "",
            onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadAccountants(_ctx.data_state.accountants.pagination.current_page))),
            onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (
                        _ctx.loadMoreAccountants(_ctx.data_state.accountants.pagination.current_page + 1)
                    )),
            searchable: false
          }, null, 8, ["value", "loading", "options", "failed"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_3,
          _createVNode(_component_the_select, {
            placeholder: "Этап выставления",
            value: _ctx.payload_state.billingPaymentStageId,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload_state.billingPaymentStageId) = $event)),
            "is-invalid": _ctx.state_form$.billingPaymentStageId.$error,
            "validation-errors": _ctx.state_form$.billingPaymentStageId.$errors,
            loading: _ctx.data_state.stages.is_loading,
            options: _ctx.data_state.stages.list,
            failed: _ctx.data_state.stages.is_failed,
            "error-text": "При получении списка этапов произошла ошибка",
            "infinite-scroll": "",
            onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadStages(_ctx.data_state.stages.pagination.current_page))),
            onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreStages(_ctx.data_state.stages.pagination.current_page + 1))),
            searchable: false
          }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_4,
          _createVNode(_component_the_select, {
            placeholder: "Период выставления",
            value: _ctx.payload_state.billingPeriodId,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payload_state.billingPeriodId) = $event)),
            loading: _ctx.data_state.periods.is_loading,
            options: _ctx.data_state.periods.list,
            failed: _ctx.data_state.periods.is_failed,
            "error-text": "При получении списка периодов произошла ошибка",
            "infinite-scroll": "",
            label: "title",
            onRefresh: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadPeriods(_ctx.data_state.periods.pagination.current_page))),
            onLoadmore: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadMorePeriods(_ctx.data_state.periods.pagination.current_page + 1))),
            searchable: false
          }, null, 8, ["value", "loading", "options", "failed"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_5,
          _createVNode(_component_the_select, {
            placeholder: "Тип выставления",
            value: _ctx.payload_state.billingWeightTypeId,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payload_state.billingWeightTypeId) = $event)),
            "is-invalid": _ctx.state_form$.billingWeightTypeId.$error,
            "validation-errors": _ctx.state_form$.billingWeightTypeId.$errors,
            loading: _ctx.data_state.weight_types.is_loading,
            options: _ctx.data_state.weight_types.list,
            failed: _ctx.data_state.weight_types.is_failed,
            "error-text": "При получении списка типов произошла ошибка",
            "infinite-scroll": "",
            onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadWeightTypes(_ctx.data_state.weight_types.pagination.current_page))),
            onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (
                        _ctx.loadMoreWeightTypes(_ctx.data_state.weight_types.pagination.current_page + 1)
                    )),
            searchable: false
          }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_6,
          _createVNode(_component_the_select, {
            placeholder: "Тариф",
            value: _ctx.payload_state.billingShipmentTariffId,
            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.payload_state.billingShipmentTariffId) = $event)),
            options: _ctx.BILLING_TARIFF_TYPES_EXTENDED,
            onChange: _ctx.onTariffChange
          }, null, 8, ["value", "options", "onChange"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createVNode(_component_the_select, {
            placeholder: "Включить биллинг для",
            value: _ctx.payload_state.billingOrderTypeId,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.payload_state.billingOrderTypeId) = $event)),
            loading: _ctx.order_types.is_loading,
            options: _ctx.order_types.list,
            failed: _ctx.order_types.is_failed,
            "error-text": "При получении типов заказа произошла ошибка",
            "search-by": "name",
            "select-by": "id",
            label: "name",
            onRefresh: _ctx.loadOrderTypes,
            searchable: false
          }, null, 8, ["value", "loading", "options", "failed", "onRefresh"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_8,
          _createVNode(_component_the_select, {
            placeholder: "Формировать транскрипт",
            value: _ctx.payload_state.billingTranscriptTypeId,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.payload_state.billingTranscriptTypeId) = $event)),
            loading: _ctx.transcript_types.is_loading,
            options: _ctx.transcript_types.list,
            failed: _ctx.transcript_types.is_failed,
            "error-text": "При получении типов транскрипта произошла ошибка",
            "search-by": "name",
            "select-by": "id",
            label: "name",
            onRefresh: _ctx.loadTranscriptTypes,
            searchable: false
          }, null, 8, ["value", "loading", "options", "failed", "onRefresh"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_checkbox, {
          label: "Биллинг",
          value: _ctx.payload_state.billingEnabled,
          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.payload_state.billingEnabled) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_checkbox, {
          label: "НДС",
          value: _ctx.state.vatEnabled,
          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.vatEnabled) = $event)),
          class: "ml-3",
          "return-integer": ""
        }, null, 8, ["value"]),
        _createVNode(_component_checkbox, {
          label: "Мгновенный транскрипт ФТЛ",
          value: _ctx.state.instantFtl,
          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.instantFtl) = $event)),
          class: "ml-3",
          "return-integer": ""
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_the_button, {
          class: "primary small",
          loading: _ctx.isLoading,
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode("Подтвердить")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      (_ctx.payload_state.billingShipmentTariffId === 7)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_the_select, {
                  placeholder: "Минимальный вес",
                  value: _ctx.new_standard_tariff_state.weight,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.new_standard_tariff_state.weight) = $event)),
                  options: _ctx.WEIGHTS,
                  searchable: false,
                  "is-invalid": _ctx.new_standard_tariff_state$.weight.$error,
                  "validation-errors": _ctx.new_standard_tariff_state$.weight.$errors
                }, null, 8, ["value", "options", "is-invalid", "validation-errors"])
              ]),
              _createVNode(_component_the_button, {
                class: "small primary whitespace-nowrap h-10",
                loading: _ctx.new_standard_tariff_state.is_loading,
                disabled: _ctx.new_standard_tariff_state.is_created,
                onClick: _ctx.createNewStandardTariff
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Создать тариф")
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onCancel"]))
}